<div class="top"></div>
<div class="section-title">{{ T["SEARCH_DEALS"][domain] }}</div>
<form [formGroup]="searchForm">
  <mat-form-field appearance="fill" class="search-field">
    <input matInput type="text" [placeholder]="T['SEARCH'][domain]" formControlName="search"
      (keyup.enter)="submitForm()" />
    <mat-hint align="start">
      <a routerLink="/search-help" class="search-help-link">Search tips</a>
    </mat-hint>
    <button mat-flat-button color="accent" class="go-button" matSuffix type="submit" (click)="submitForm()">
      <mat-icon>search</mat-icon>
    </button>
  </mat-form-field>
  <div class="sort-by section-title">{{ T["SORT_BY"][domain] }}</div>
  <mat-form-field class="search-field" appearance="fill">
    <mat-select (selectionChange)="onSortChanged($event)" placeholder="Sort Order" formControlName="sort">
      @for (order of sortOrders; track order) {
        <mat-option [value]="order.id">{{
          order.name[domain]
        }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
  <div class="section-title">{{ T["ESTIMATED_SAVINGS"][domain] }}</div>
  <mat-form-field appearance="fill" class="input-field">
    <input matInput type="number" placeholder="Min" formControlName="minSavings" (keyup.enter)="submitForm()" />
    <span matSuffix>%&nbsp;</span>
  </mat-form-field>
  <div class="section-title">{{ T["ESTIMATED_PRICE_DIFFERENCE"][domain] }}</div>
  <mat-form-field appearance="fill" class="input-field">
    <span matPrefix>{{ getCurrencySymbol(currencyMap[domain], "narrow") }}&nbsp;</span>
    <input matInput type="number" placeholder="Min" formControlName="minDifference" (keyup.enter)="submitForm()" />
  </mat-form-field>
  <div class="section-title">{{ T["USED_PRICE"][domain] }}</div>
  <mat-form-field appearance="fill" class="input-field">
    <input matInput type="number" placeholder="Min" formControlName="minUsed" (keyup.enter)="submitForm()" />
    <span matPrefix>{{ getCurrencySymbol(currencyMap[domain], "narrow") }}&nbsp;</span>
  </mat-form-field>
  <mat-form-field appearance="fill" class="input-field">
    <input matInput type="number" placeholder="Max" formControlName="maxUsed" (keyup.enter)="submitForm()" />
    <span matPrefix>{{ getCurrencySymbol(currencyMap[domain], "narrow") }}&nbsp;</span>
  </mat-form-field>
  <div class="section-title">{{ T["NEW_PRICE"][domain] }}</div>
  <mat-form-field appearance="fill" class="input-field">
    <input matInput type="number" placeholder="Min" formControlName="minNew" (keyup.enter)="submitForm()" />
    <span matPrefix>{{ getCurrencySymbol(currencyMap[domain], "narrow") }}&nbsp;</span>
  </mat-form-field>
  <mat-form-field appearance="fill" class="input-field">
    <input matInput type="number" placeholder="Max" formControlName="maxNew" (keyup.enter)="submitForm()" />
    <span matPrefix>{{ getCurrencySymbol(currencyMap[domain], "narrow") }}&nbsp;</span>
  </mat-form-field>
</form>
<div class="section-title">{{ T["CATEGORIES"][domain] }}</div>
@if (showBoundMatSelectionList) {
  <mat-selection-list #selectionList color="accent" [formControl]="categoriesControl">
  <mat-list-option #allOption [value]="-1" checkboxPosition="before" (click)="
      allOption.selected
        ? selectionList.selectAll()
        : selectionList.deselectAll()
    ">
      {{ T["ALL"][domain] }}
    </mat-list-option>
    @for (category of categories; track category; let i = $index) {
      <mat-list-option checkboxPosition="before"
        (click)="allOption.selected = false" [value]="i">
        {{ category }}
      </mat-list-option>
    }
  </mat-selection-list>
}
<div class="button-container">
  <button mat-flat-button color="accent" class="submit-button" mat-button type="submit" (click)="submitForm()">
    <mat-icon>search</mat-icon>
    {{ T["SEARCH"][domain] }}
  </button>
</div>